export const createDomElementHandler = (
  type = 'div',
  _classList: string[] | string = [],
  attributes: { [attrKey: string]: string } = null,
  innerHtml: string = null
) => {
  const newElement = document.createElement(type);
  const classList = Array.isArray(_classList) ?
    _classList :
  _classList.split(' ').filter(Boolean);
  classList?.forEach(className => {
    if (!className?.length) return;
    newElement.classList.add(className);
  });
  if (attributes) {
    for (const [attributeName, value] of Object.entries(attributes)) {
      newElement.setAttribute(attributeName, value);
    }
  }
  if (innerHtml?.length) {
    newElement.innerHTML = innerHtml;
  }
  return newElement;
}

export const createSvg = (iconName: string) => {
  const SVG_NS = "http://www.w3.org/2000/svg";
  const XLINK_NS = "http://www.w3.org/1999/xlink";
  const svg = document.createElementNS(SVG_NS, "svg");
  svg.classList.add("ab-icon");
  svg.setAttribute("aria-hidden", "true");
  svg.style.display = "inline";
  const use = document.createElementNS(SVG_NS, "use");
  // Standard moderno
  use.setAttribute("href", `#${iconName}`);
  // Fallback (Safari vecchi / casi particolari)
  use.setAttributeNS(XLINK_NS, "xlink:href", `#${iconName}`);
  svg.appendChild(use);
  return svg;
};